"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var EventManagement_module_css_1 = __importDefault(require("./EventManagement.module.css"));
var TimeScheduleField = function (_a) {
    var _b = _a.schedules, schedules = _b === void 0 ? [] : _b, label = _a.label, source = _a.source;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var days = [
        { id: "1", name: t("Monday"), initial: "M" },
        { id: "2", name: t("Tuesday"), initial: "T" },
        { id: "3", name: t("Wednesday"), initial: "W" },
        { id: "4", name: t("Thursday"), initial: "T" },
        { id: "5", name: t("Friday"), initial: "F" },
        { id: "6", name: t("Saturday"), initial: "S" },
        { id: "7", name: t("Sunday"), initial: "S" }
    ];
    return (react_1.default.createElement("div", { className: EventManagement_module_css_1.default["time-schedule-list-container"] }, schedules.map(function (schedule) { return (react_1.default.createElement("div", { key: schedule.id, className: EventManagement_module_css_1.default["schedule-row-list"] },
        react_1.default.createElement("div", { className: "".concat(EventManagement_module_css_1.default["time-range"], " ns-font-family") },
            react_1.default.createElement("span", { style: { color: "var(--info-color)" } },
                schedule.start,
                " ",
                react_1.default.createElement(react_1.default.Fragment, null,
                    "<>",
                    " "),
                " ",
                schedule.end)),
        react_1.default.createElement("div", { className: EventManagement_module_css_1.default["days-container-list"] }, days.map(function (day) { return (react_1.default.createElement(q_play_components_1.Button, { key: day.id, variant: "empty", style: {
                backgroundColor: schedule.days.includes(day.id) ? "var(--info-color)" : "var(--hover-color)",
                color: schedule.days.includes(day.id) ? "var(--secondary-color)" : "var(--info-color)",
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px"
            }, size: "small", text: day.initial })); })))); })));
};
exports.default = TimeScheduleField;
